import { ViewEncapsulation,  Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { environment } from 'src/environments/environment';
import { HttpErrorResponse } from '@angular/common/http';
import { MechanicsService } from 'src/app/commons/_services/mechanics.service';
import { PreferencesService } from 'src/app/commons/_services/preferences.service';
import { QueryParamsService } from 'src/app/commons/_services/queryParams.service';
import { RecentSearchesService } from 'src/app/commons/_services/recentSearches.service';
import { ReportsService } from 'src/app/commons/_services/reports.service';
import { SearchService } from 'src/app/commons/_services/search.service';
import { SearchFacets, IDXDocument } from 'src/app/commons/interfaces';
import { instanceType, decrypt } from '../../utils';
import { SearchSolrResponse, SolrError } from 'src/app/commons/interfaces';

//const queryString = require('query-string');


@Component({
	selector: 'results-holder',
	templateUrl: './results-holder.component.html',
	styleUrls: ['./results-holder.component.css'],
	changeDetection: ChangeDetectionStrategy.Default, // OnPush --> blank page...
	encapsulation: ViewEncapsulation.None,
	standalone: false
})

export class ResultsHolderComponent implements OnInit {

	public solrFacets: SearchFacets = null
	public highlighting: any = {}
	public isMock: boolean

	// Reporting stuff
	public newReportName: string = "";
	public checkedReports: any = {}; // { "fruits": true, "Test 03": true, "vegetables": false }

	constructor(public ss: SearchService,
		private rss: RecentSearchesService,
		public ms: MechanicsService,
		public ps: PreferencesService,
		public qs: QueryParamsService,
		public rs: ReportsService) {
	}

	ngOnInit() {
		const l = `pageResult ngOnInit - `

		if (!this.rs.reportsNames.length) 
			this.rs.loadData();

		this.ss.searchResult.numFound = -1 // To display "Loading..." in comp-results-info
	}

	isResultVisible(_id: string) {
		return this.ss.resultsVisibility[_id]
	}



	setSearchResult(searchResult:any = {}) {

		const l = `resultsComponent setSearchResult() - `
		
		// console.log(`${l}setting searchResult = `,searchResult)

		// set the result in the search service cache
		// will also update the results-info
		let cid: string = this.qs.getQP('_');
		
		this.ss.searchResult.init(searchResult, cid);

		this.isMock = searchResult.isMock
		this.highlighting = searchResult.highlighting || {}
		this.solrFacets = searchResult.facets
		for (let doc of this.ss.searchResult.docs) {
			this.ms.computeIDXDocumentCustomKeys(doc, this.highlighting[doc.st13])
		}
		this.rss.addRecentSearch(this.qs.getQP("*"))
		document.getElementsByClassName('mainGrid')[0].scrollTo({ top: 0, behavior: 'smooth' });

		this.ss.observeResults();
	}

	setSearchError(err: HttpErrorResponse) {

		const l = `resultsComponent setSearchError() - `

		switch (err.status) {
			case 403:
				// stay in the search result page and display the same results as before

				const resutsToSet = this.ss.searchResult.currentResult
				// console.log(`${l}resutsToSet = `, resutsToSet)
				this.setSearchResult(resutsToSet)
				this.ms.setSearchError(err)
				break
			default:
				// back to the search form
				this.qs.queryParamsObjectToUrl(this.ms.makeRoute({ path: this.ms.endpoint, caller: l })) // go back to search form
				this.ms.setSearchError(err)  // error mesage will disappear on search form OnDestroy
				break
		}

	}



	// -----------------------------------
	// search results menu handlers
	// -----------------------------------
	// { name : name_of_the_menu } --> { name : "sort" }
	onMenuChoice($event): void {

		const l = `pageResults onMenuChoice() - `

		// console.log(`${l}$event = `, $event)

		// $event.name can be "layout", "sort", "rows"
		this[`_menuchoice_${$event.name}`]($event.value)

		// store the preferences made by the menu
		this.ps.storePreferences()
	}

	// { name : name_of_the_menu, value: value_of_the_choice_if_any } --> { name : "watch" }
	onMenuAction($event): void {

		const l = `pageResults onMenuAction() - `

		// $event.name can be "export", "watch", "save"
		this[`_menuaction_${$event.name}`]($event.value)
	}

	_cloneAndFilterKeys = (obj, keys) => {
	    if (Object(obj) !== obj)
	       return obj;
	    else if (Array.isArray(obj))
	       return obj.map(o => this._cloneAndFilterKeys(o, keys));

	    return Object.fromEntries(
	        Object.entries(obj)
	              .filter(([k, v]) => !keys.includes(k))
	              .map(([k, v]) => ([k, this._cloneAndFilterKeys(v, keys)])
	    ));
	}

	_menuaction_export(format: string, notified: boolean = false): void {

		const l = `resultsComponent _menuaction_export() - `

		//this.ms.setLoading(true);

		// listen to the message from iframe
		//window.addEventListener('message', this._menuaction_export_done.bind(this), false);

		let refpayload = this.qs.queryParams[this.ms.endpoint];
		refpayload = refpayload["asStructure"];
		let payload = JSON.parse(refpayload);
		payload = this._cloneAndFilterKeys(payload, ['_', 'i', '_id', 'fg']);
		const stringified = JSON.stringify(payload);

		// we could get the query in its human readable form, which is in the queryparams2human component

		let currentURL = window.location.href;
		// remove url parameters "_"


		const reportName= stringified;
		this.doExport(reportName, format, currentURL);
	}

	_menuaction_export_done(event): void {

		const l=`_menuaction_export_done`

		// console.log(`${l}`)

		if (event.origin === environment[instanceType()].appUrl && event.data === 'export_done') {
			//this.ms.setLoading(false);
			window.removeEventListener('message', this._menuaction_export_done)
		}
	}

	_menuaction_watch(): void { alert('work in progress') }
	_menuaction_save(): void { alert('work in progress') }

	_menuchoice_layout(layout: string): void {
		const l: string = `pageResult _menuchoice_layout() - `
		this.ps.setPref("layout", layout)

		this.ss.observeResults()
	}

	_menuchoice_sort(order: string): void {
		const l: string = `pageResult _menuchoice_sort() - `

		// when sorting, start from the beginning
		this.qs.rmQP("start")
		this.qs.setQP("sort", order)
		this.ms.supressFacets = true // a switch that will be read and reset in search
		this.qs.queryParamsObjectToUrl()
	}

	_menuchoice_rows(rows: number): void {
		const l: string = `pageResult _menuchoice_rows() - `

		// when number of rows change, start from the beginning
		this.qs.rmQP("start")
		this.qs.setQP("rows", rows)
		this.ms.supressFacets = true // a switch that will be read and reset in search
		this.qs.queryParamsObjectToUrl()
	}


	// -----------------------------------
	// search results handlers
	// -----------------------------------


	get windowWidth(): number {
		return window.innerWidth
	}

	// ------------------
	// TABLE INTERACTIONS
	// ------------------
	get isAllSelected(): boolean {
		return this.ss.searchResult.docs.every(result => result && result.selected)
	}

	get countSelectedResults(): number {
		return this.ms.cachedSt13s.length
	}

	deselectAll() {
		this.ss.searchResult.docs.forEach(result => result.selected = false)
	}

	async onPagination($event): Promise<void> {

		const l: string = `pageResult onPagination() - `
		// console.log(`${l}$event = `, $event);

		this.ms.supressFacets = true // a switch that will be read and reset in search
		this.qs.setQP("start", $event.first)
		await this.qs.queryParamsObjectToUrl()
	}

	get checkedReportsKeys() {
		return Object.keys(this.checkedReports).filter(key => this.checkedReports[key])
	}

	async addToReports() {

		const l = `PageResults addToReports() - `
		// Add the last selections to the cache

		// console.log(`${l}this.checkedReportsKeys = `, this.checkedReportsKeys);

		for (let reportName of this.checkedReportsKeys) {// ["fruits", "Test 03", "vegetables"]
			if (reportName === "$$new") reportName = "" + this.newReportName;
			await this.rs.setReport(reportName, this.ms.cachedSt13s);
		}

		this.checkedReports = []
		this.newReportName = ""

		this.deselectAll();
		this.ms.clearCache();
		this.ms.tooltips.addedToReports = true;
		setTimeout(() => {
			this.ms.tooltips.addedToReports = false;
		}, 3000)
	}

	/**
	 * Results export handler 
	 **/

	doExport(reportName: string, format: string, currentURL: string) {

		this.ms.setLoading(true);
		//this.isExporting = true;

		// Server-side export approach
		this.exportResultsServerSide(reportName, format, currentURL)
			.then(() => {
				this.ms.setLoading(false);
				//this.isExporting = false;
			})
			.catch((error) => {
				//console.error('Export failed:', error);
				this.ms.setLoading(false);
				//this.isExporting = false;
				// Optionally show error message to user
				this.setSearchError(new HttpErrorResponse({ status: 500, error: 'Export failed. Please try again.' }));
			});
	}

	b64toBlob(b64Data, contentType='', sliceSize=512) {
	  	const byteCharacters = atob(b64Data);
	  	const byteArrays = [];

	  	for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
	    	const slice = byteCharacters.slice(offset, offset + sliceSize);

	    	const byteNumbers = new Array(slice.length);
	    	for (let i = 0; i < slice.length; i++) {
	      		byteNumbers[i] = slice.charCodeAt(i);
	    	}

	    	const byteArray = new Uint8Array(byteNumbers);
	    	byteArrays.push(byteArray);
	  	}
	    
	  	const blob = new Blob(byteArrays, {type: contentType});
	  	return blob;
	}

	private async exportResultsServerSide(reportName: string, format: string, currentURL: string): Promise<void> {
		const l = `pageReports exportResultsServerSide() - `;
		
		try {
			// Get the data to be exported, 
			// problem, if the result numbers is equal to the result per page, we need to redo a query
			// to reach the maximum record export (180, or lower if less results)
			const currentNbResults = this.ss.searchResult.docs.length;

			let docs: string[] = [];
			for (let doc of this.ss.searchResult.docs) {
				docs.push(doc["st13"]);
			}

			//console.log(`${l}Exporting docs = `, docs);

			//const reportData = this.reports[reportName];
			if (!docs || docs.length == 0) {
				throw new Error('Data not found');
			}

			// Extract only ST13 identifiers instead of full documents
			const st13List = docs;

			// ensure that the lang information is properly refreshed
			this.ms.switchLang();

			let localBases64: string[];
			let localStrategy: string;
			if (['similarlogo', 'advancedsearch'].includes(this.ms.endpoint) && 
				this.ms.bases64?.length) {
				localBases64 = this.ms.bases64;
				localStrategy = this.qs.getQP("strategy");
			}

			// Prepare the export payload with just ST13s
			// as additional metadata, we add the current URL for reference in 
			// the extracted result document and current result per page
			// to decide if additional search is necessary to complement the list
			// of results to be exported, and the image base64 if part of the query
			const exportPayload = {
				reportName: reportName,
				format: format,
				st13List: st13List, // Send only ST13 identifiers
				lang: this.ms.lang,
				isReport: false,
				// Add any other metadata needed for the export
				metadata: {
					generatedAt: new Date().toISOString(),
					totalRecords: st13List.length,
					office: this.ms.officeCC,
					originalUrl: currentURL,
					resultPerPage: this.qs.getQP('rows'),
					bases64: localBases64 || null,
					strategy: localStrategy || null
				}
			};

			let acceptType = '*/*';
			if (format === "pdf")
				acceptType = 'application/pdf';
			else if (format === "docx")
				acceptType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
			else if (format === "xlsx")
				acceptType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

			// Call the server-side export endpoint
			const response = await fetch(`${this.ms.environment.backendUrl}/reportExport`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Accept': acceptType,
					'HashSearch': localStorage.getItem(`${instanceType()}.hashSearches`) || ""
				},
				body: JSON.stringify(exportPayload)
			});

			if (!response.ok) {
				throw new Error(`Export request failed: ${response.status} ${response.statusText}`);
			}

			// Handle the file download
			const base64Data = await response.text();
			//console.log(base64Data);
			// the body is in base64
			const blob = this.b64toBlob(base64Data, acceptType);
			const fileName = `export_${new Date().toISOString().split('T')[0]}.${format.toLowerCase()}`;
			
			// Create download link and trigger download
			const downloadUrl = window.URL.createObjectURL(blob);
			const link = document.createElement('a');
			link.href = downloadUrl;
			link.download = fileName;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			window.URL.revokeObjectURL(downloadUrl);

			//console.log(`${l}Successfully exported ${reportName} as ${format}`);

		} catch (error) {
			console.error(`${l}Export failed:`, error);
			throw error;
		}
	}

}


